module.exports = __webpack_public_path__ + "img/spinner.b714d78c.svg";